export default {
  BANNER: 'BANNER',
  BANNERS: 'BANNERS',
  CATEGORY: 'CATEGORY',
  CLIP: 'CLIP',
  EPISODE: 'EPISODE',
  EPISODES: 'EPISODES',
  LIVE: 'LIVE',
  LIVES: 'LIVES',
  PROGRAMME: 'PROGRAMME',
  PROGRAMMES: 'PROGRAMMES',
  SECTION: 'SECTION',
  SECTIONS: 'SECTIONS',
  SERIAL: 'SERIAL',
  SERIES: 'SERIES',
  SEASON: 'SEASON',
  SEASONS: 'SEASONS',
  VOD: 'VOD',
  VODS: 'VODS',
  TIMESHIFT: 'TIMESHIFT',
  N_PVR: 'N_PVR',
  DOWNLOAD: 'DOWNLOAD',
  CATCH_UP: 'CATCH_UP',
};
